<template>
  <div>
    <div class="navCard">
      <div class="navCard-top">
        <div class="navCard-top-l">
          <img v-if="object.tp" :src="object.tp" @click="preViewImg(object.tp)"/>
           <img v-else src="@images/headerDft.png"/>
        </div>
        <div class="navCard-top-r">
          <h3>{{object.name}}  <span v-if="object.zw" class="tag">{{object.zw}}</span> </h3>
          <p>{{object.szdw}} | {{object.lxdh}}</p>
          <p>{{object.sysOrgCodeXian_dictText}}{{object.sysOrgCodeZhen_dictText}}{{object.sysOrgCode_dictText}}</p>
        </div>
      </div>
    </div>
    <div class="content_nr">
      <div class="label">简介：</div>
       <div class="desc">{{object.jj}}</div>
    </div>
  </div>
</template>

<script>
import { getAction,postAction} from '@/api/manage'
import { ImagePreview } from 'vant'
export default {
  data() {
    return {
      downOption: {
        auto: false, //是否在初始化后,自动执行downCallback; 默认true
      },
      object:{},
      params:this.$route.query,
    }
  },
  created() {
    this.getData();
  },
  mounted() {
  },
  methods: {
    getData() {
      let params = {id:this.params.id};
      getAction('/zhshj/csqryglsgyl/page-app',params)
      .then((res) => {
        let object = res.result.records[0];
        this.object  = object;
      })
    },
    preViewImg(img){
      let arr = [img];
      ImagePreview(arr);
    },
   
    
  },
}
</script>

<style lang="less" scoped>
// 个人简介
.navCard{
  width: 100%;
  padding: 20px 20px 40px;
  box-sizing: border-box;
  background: #000000;
  background-image: url("../../assets/images/hmhq/bjk.png");
  color: white;
  &-top{
    width: 100%;
    display: flex;
    justify-content: space-between;
    &-l{
      width: 100px;
      height: 100px;
      padding: 4px;
      box-sizing: border-box;
      border-radius: 50%;
      background: white;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    &-r{
      width: 65%;
      h3{
        font-size: 18px;
        padding: 8px 0px;
        margin: 0px;
        display: flex;
        align-items: center;
        .tag{
          display: inline-block;
          margin-left: 10px;
          padding: 0 15px;
          height: 20px;
          line-height: 20px;
          font-size: 12px;
          color: #937038;
          background-image: linear-gradient(180deg, #FFF7EA 0%, #FDECD0 100%);
          border-radius: 25px;
        }
      }
      p{
        margin: 0px;
        padding: 0px;
        line-height: 26px;
        font-size: 14px;
      }
    }
  }
  &-bottom{
    width: 100px;
    display: flex;
    justify-content: center;
    p{
      margin: 10px 0px 0px;
    }
  }
}

.title {
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}
.desc {
  color: #696969;
  margin-bottom: 12px;
  font-size: 14px;
}

.fbr {
  margin-right: 8px;
}

.time {
  margin-left: 8px;
}

.content {
  color: #303133;
  text-indent: 2em;
  line-height: 22px;
}

.bottom {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 60px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
}

.image{
  max-width: 100%;
  margin-top: 12px;
}
.content_nr{
  padding: 20px 12px;
  min-height: 200px;
  background: white;
  margin: -20px 0px 0px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;

  .label{
    color: #1a1a1a;
  }
}
</style>
<style>
.h5-html img {
  width: 100%;
  height: auto;
  object-fit: fill;
}
</style>
